import Navbar from "./components/Navbar";
import Logo from "./components/Logo";

// ***********************************************************************************************************

export default function Header() {
  // ***********************************************************************************************************

  return (
    <header className="h-16 fixed w-full bg-white z-10 shadow-[0px_1px_4px_0px_#92a1b04d]">
      <div className="container flex items-center justify-between h-full">
        <Logo />

        {/* *********************************************************************************************************** */}

        <Navbar />
      </div>
    </header>
  );
}
